export const NotesBookmarksModule = {
    state: {
        totalNotesBookmarks: 0,
    },
    getters: {
        getTotalNotesBookmarks: (state) => state.totalNotesBookmarks,
    },
    mutations: {
        setTotalNotesBookmarks (state, count) {
            state.totalNotesBookmarks = count;
        }
    },
    actions: {
        updateTotalNotesBookmarks({ commit }, count) {
          commit('setTotalNotesBookmarks', count);
        }
    }
}
